// extracted by mini-css-extract-plugin
module.exports = {"slideContent":"slider_slideContent__2tmQJ","slideContentText":"slider_slideContentText__1CUXF"};